if (!customElements.get('cart-privacy-agreement')) {
  class CartPrivacyAgreement extends HTMLElement {
    constructor() {
      super();
      this.checkbox = this.querySelector('input[type="checkbox"]');
      this.checkoutButtons = document.querySelector('.checkout-buttons');

      this.init();
    }

    init() {
      this.toggleCheckoutState();
      this.checkbox.addEventListener('change', this.toggleCheckoutState.bind(this));
    }

    toggleCheckoutState() {
      const isChecked = this.checkbox.checked;

      if (this.checkoutButtons) {
        this.checkoutButtons.style.opacity = isChecked ? '1' : '0.5';
        this.checkoutButtons.style.pointerEvents = isChecked ? 'auto' : 'none';
      }
    }
  }

  customElements.define('cart-privacy-agreement', CartPrivacyAgreement);
}
